import React, { useState } from "react";
import { Image, Row, Col, Button, Modal, Form } from "react-bootstrap";
import { TextField, InputLabel, FormControl, Select } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import SuperAdminCall from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import SuperAdminSMS from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSMS";
import SuperAdminNotification from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminNotification";
import { SuperAdminFlag } from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminFlag";
import { SuperAdminBlockUser } from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminBlockUser";
import { SuperAdminDeleteUser } from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminDeleteUser";
import { SuperAdminResetPassword } from "../../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminResetPassword";
import isEmpty from "../../../../../../store/validation/is-Empty";

export const AuthorizedUserProfilePage = (props) => {
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [state, setState] = useState({
    code: "",
    country: "",
    state: "",
    role: "",
  });

  const handleCloseView = () => setShowView(false);
  const handleShowView = () => setShowView(true);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => {
    setShowEdit(true);
    setShowView(false);
  };
  const handleChangeCode = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
  };

  const [pic, setPic] = useState(null);
  const uploadImage = (e) => {
    setPic(URL.createObjectURL(e.target.files[0]));
  };

  return (
    <React.Fragment>
      <div className="enAuthorizedUsersBox">
        <Row>
          <Col lg={5} md={8} className="py-4">
            <div className="d-flex justify-content-between align-items-start">
              <div className="pr-2 d-flex align-items-center">
                <div className="user-profile-image w-75 h-75 mr-3">
                  <Image
                    fluid
                    src={`${props?.userData?.photo_thumbnails ? props?.userData?.photo_thumbnails : require("../../../../../../assets/images/ActionImages/demoprofile.jpg")}`}
                  />
                </div>
                <div className="w-100">
                  <div className="f16-700">
                    {props.userData.firstName + " " + props.userData.lastName}
                  </div>
                  <div className="f11-400 mb-3">
                    {props.userData.selected_position}
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div className="d-flex flex-wrap align-items-center enWidth130">
                  <div className="mb-3">
                    <SuperAdminCall />
                  </div>
                  <Button variant="link" className="enIconBtn mb-3 mr-3">
                    <Image
                      src={require("../../../../../../assets/images/UserManagement/forum.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button>
                  <Button variant="link" className="enIconBtn mr-3">
                    <Image
                      src={require("../../../../../../assets/images/UserManagement/email.svg")}
                      alt="Message"
                      title="SMS"
                      fluid
                    />
                  </Button>
                  <SuperAdminNotification />
                </div>
              </div>
            </div>
          </Col>
          <Col lg={2} md={4} className="py-4">
            <div className="f10-400 mb-1">Email</div>
            {!isEmpty(props.userData.enquiry_emails) &&
              props.userData.enquiry_emails.map((singleitem, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="f13-700 mb-3 text-break text-lowercase">
                      {singleitem}
                    </div>
                  </React.Fragment>
                );
              })}
            <div className="f10-400 mb-1">Phone</div>
            {!isEmpty(props.userData.phone_numbers) &&
              props.userData.phone_numbers.map((singleitem, index) => {
                return (
                  <React.Fragment key={index}>
                    <div className="f13-700">
                      {singleitem.country_code + " " + singleitem.mobile_no}
                    </div>
                  </React.Fragment>
                );
              })}
          </Col>
          <Col lg={5} md={12} className="py-4">
            <Row>
              <Col md={6}>
                <div className="f10-400 mb-1">Address</div>
                <div className="f13-700"></div>
              </Col>
              <Col md={6}>
                <div className="mb-3 d-flex justify-content-end">
                  <SuperAdminResetPassword />
                  {/* <SuperAdminFlag />
                  <SuperAdminBlockUser block={true} /> */}
                </div>
                <div className="d-flex justify-content-end">
                  <Button
                    variant="link"
                    className="enIconBtn mr-3"
                    onClick={handleShowView}
                  >
                    <Image
                      src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button>
                  <Button
                    variant="link"
                    className="enIconBtn mr-3"
                    onClick={handleShowEdit}
                  >
                    <Image
                      src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button>
                  <SuperAdminDeleteUser />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <Modal show={showView} onHide={handleCloseView} centered size="lg">
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24-700">Authorized User</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <Row>
            <div className="col-md-8 d-flex align-items-center">
              <div className="user-profile-image m-0">
                <Image
                  src={`${props?.userData?.photo_thumbnails ? props?.userData?.photo_thumbnails : require("../../../../../../assets/images/ActionImages/demoprofile.jpg")}`}
                />
              </div>
              <div className="pl-3">
                <div className="f18-700 pb-2">{props.userData.firstName + " " + props.userData.lastName}</div>
                <div className="f12-400">{props.userData.selected_position}</div>
              </div>
            </div>
            <div className="col-md-4 d-flex justify-content-end">
              <div className="enWidth130 d-flex justify-content-end flex-wrap align-items-center">
                <div className="mb-3">
                  <SuperAdminCall />
                </div>
                <Button variant="link" className="enIconBtn mb-3 mr-3">
                  <Image
                    src={require("../../../../../../assets/images/UserManagement/forum.svg")}
                    alt="View"
                    title="View"
                    fluid
                  />
                </Button>
                <SuperAdminSMS />
                <SuperAdminNotification />
              </div>
            </div>
            <Col lg={6} md={6} className="py-4">
              <div className="f11-400 mb-1">Email</div>
              {!isEmpty(props.userData.enquiry_emails) &&
                props.userData.enquiry_emails.map((singleitem, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="f13-700 mb-3 text-break">{singleitem}</div>
                    </React.Fragment>
                  );
                })}
            </Col>
            <Col lg={6} md={6} className="py-4">
              <div className="f11-400 mb-1">Phone</div>
              {!isEmpty(props.userData.phone_numbers) &&
                props.userData.phone_numbers.map((singleitem, index) => {
                  return (
                    <React.Fragment key={index}>
                      <div className="f13-700">
                        {singleitem.country_code + " " + singleitem.mobile_no}
                      </div>
                    </React.Fragment>
                  );
                })}
            </Col>
            {/* <Col lg={6} md={6} className="pb-4">
              <div className="f11-400 mb-1">Address</div>
              <div className="f14-700 mb-3 text-break">
                Survey No:32/2, Gurukrupa Hall, Near Dmart, Ambegaon BK, Pune,
                Maharashtra 411046
              </div>
            </Col> */}
            <Col md={12} className="d-flex">
              <SuperAdminResetPassword />
              {/* <SuperAdminFlag />
              <SuperAdminBlockUser block={true} /> */}
              <Button
                variant="link"
                className="enIconBtn mr-3"
                onClick={handleShowEdit}
              >
                <Image
                  src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                  alt="View"
                  title="View"
                  fluid
                />
              </Button>
              <SuperAdminDeleteUser />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      <Modal show={showEdit} onHide={handleCloseEdit} centered size="lg">
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24_500_HelveticaNeue">
            Edit Authorized User
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <Form>
            <Row>
              <Col md={12}>
                <div className="enUploadEditPic">
                  <div className="user-profile-image w-100 h-100">
                    <Image
                      fluid
                      className="w-100 h-100"
                      src={
                        pic
                          ? pic
                          : require("../../../../../../assets/images/ActionImages/demoprofile.jpg")
                      }
                    />
                  </div>
                  <div className="enUploadIcon">
                    <input
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      onChange={(e) => uploadImage(e)}
                    />
                    <Image
                      src={require("../../../../../../assets/images/UserManagement/picUpload.svg")}
                      alt="chairs"
                      title="chairs"
                      className="w-100 h-100"
                    />
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    label="Name"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    type="email"
                    label="Email Address"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Row>
                  <Col xs={4} className="pr-0">
                    <FormControl variant="outlined" className="w-100">
                      <Select
                        value={state.code}
                        onChange={handleChangeCode}
                        inputProps={{
                          name: "code",
                        }}
                      >
                        <option value={+91}>+91</option>
                      </Select>
                    </FormControl>
                  </Col>
                  <Col xs={8}>
                    <Form.Group>
                      <TextField
                        id="outlined-basic"
                        label="Phone Number"
                        variant="outlined"
                        className="w-100"
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-role">Role</InputLabel>
                    <Select
                      value={state.role}
                      onChange={handleChangeCode}
                      label="Role"
                      inputProps={{
                        name: "role",
                        id: "outlined-role",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="role">Role</option>
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-country">country</InputLabel>
                    <Select
                      value={state.country}
                      onChange={handleChangeCode}
                      label="Country"
                      inputProps={{
                        name: "country",
                        id: "outlined-country",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="country">Country</option>
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <FormControl variant="outlined" className="w-100">
                    <InputLabel htmlFor="outlined-state">State</InputLabel>
                    <Select
                      value={state.state}
                      onChange={handleChangeCode}
                      label="state"
                      inputProps={{
                        name: "state",
                        id: "outlined-state",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      <option value="state">State</option>
                    </Select>
                  </FormControl>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <TextField
                    label="City"
                    type="text"
                    variant="outlined"
                    className="w-100"
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex align-items-center pt-5">
              <Button
                variant="outline-secondary"
                className="mr-4 px-5 py-2"
                onClick={handleCloseEdit}
              >
                Cancel
              </Button>
              <Button variant="danger" className="px-5  py-2" type="submit">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
